export const getEducationSettingsQuery = `
  query GetEducationSettings {
    getEducationSettings {
      code
      settings {
        id
        companyId
        billInactiveStudents
        blockPromotionIfOutstandingFees
        allowOverpayment
        allowNegativeStock
        requireApprovalForWriteOff
        requireApprovalForPaymentReversal
        noMatchingFeeBlocksBilling
        paymentAllowedForWithdrawnStudents
        version
      }
    }
  }
`;

export const updateEducationSettingsMutation = `
  mutation UpdateEducationSettings($input: UpdateEducationSettingsInput!) {
    updateEducationSettings(input: $input) {
      code
      settings {
        billInactiveStudents
        blockPromotionIfOutstandingFees
        allowOverpayment
        allowNegativeStock
        requireApprovalForWriteOff
        requireApprovalForPaymentReversal
        noMatchingFeeBlocksBilling
        paymentAllowedForWithdrawnStudents
        version
      }
    }
  }
`;
